import React from "react";
import "./Carousel.css";

const IMAGE_WIDTH = 300; // Width of each carousel image

const Carousel = ({ imageList = [] }) => {
  const [currentPos, setCurrentPos] = React.useState(0);

  const onClickScroll = (position) => {
    const imageWidth = IMAGE_WIDTH;
    const container = document.querySelector(".carousel-slide-container");
    container.scrollTo({
      left: position * imageWidth,
      behavior: "smooth",
    });
  };

  const handleScroll = (event) => {
    // change the button size of current active button
    const imageWidth = IMAGE_WIDTH;
    const scrollLeft = event.target.scrollLeft;
    const currentIndex = Math.round(scrollLeft / imageWidth);
    setCurrentPos(currentIndex);
  };

  return (
    <div className="carousel-main-container">
      <div className="carousel-slide-container" onScroll={handleScroll}>
        <div
          className="carousel-inner-container"
          style={{ width: `${IMAGE_WIDTH * imageList?.length}px` }}
        >
          {imageList?.map((image, index) => (
            <img
              key={`img-${index + 1}`}
              img-position={index}
              src={image.img}
              alt={`carousel-${index}`}
            />
          ))}
        </div>
      </div>
      <div className="carousel-btn-container">
        {imageList?.map((image, index) => (
          <div
            key={`btn-${index + 1}`}
            role="presentation"
            className={`carousel-btn ${
              currentPos === index ? "carousel-btn-active" : ""
            }`}
            id={`carousel-btn-${index}`}
            onClick={() => onClickScroll(index)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
